//@flow
export const ENTITY_NAME_ID = 'masterRider';
export const ENTITY_EXPORT_ID = 'RIDER_MASTER';
export const ENTITY_TABLE_ID = 'RiderMaster';
export const ENTITY_TYPE = 'RIDER';
